import React, { useEffect } from "react";
import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ContinueCancelButtons from "../../../../shared/components/ContinueCancelButtons.jsx";
import BackAnchor from "../../../../shared/components/BackAnchor.jsx";
import { addNewAdultAction, removeAdultAction, removeFiles, setQuestionAnswer } from "../../../../redux/actions.js";

const QualifyView = ({ t, i18n }) => {
  const { questionDataList } = useSelector((state) => state?.app);
  const userData = useSelector((state) => state.app);
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const letter =
    questionDataList[
      questionDataList.findIndex((question) => question.questionNumber === 2)
    ].questionAnswer?.toLowerCase();
  const billUpload =
    questionDataList[
      questionDataList.findIndex((question) => question.questionNumber === 4)
    ].questionAnswer?.toLowerCase() === 'yes';
  const otherAdult =
    questionDataList[
      questionDataList.findIndex((question) => question.questionNumber === 7)
    ].questionAnswer?.toLowerCase() === "yes";

  const houseHoldType =
    questionDataList[
      questionDataList.findIndex((question) => question.questionNumber === 8)
    ].questionAnswer?.toLowerCase()
  const moreAdults = houseHoldType === "two or more adults(no kids)" || houseHoldType === "two or more adults(with kids)"

  useEffect(() => {
    if (i18n?.language === "en") {
      document.title =
        "You may qualify for the rebate - HARP - Government of Nova Scotia";
    } else {
      document.title =
        "Vous pourriez avoir droit à la remise – PAC – Gouvernement de la Nouvelle-Écosse";
    }
  }, [i18n.language]);

  const onNext = () => {
    try {
      navigate(`/${i18n.language}${t("routes.personal_information")}`);
    } catch (e) {
      console.log(e);
    }
  };

  const handleReduxCleanup = () => {
    if (userData?.otherAdultsInformation.length > 0) {
      userData?.otherAdultsInformation.map((x) => {
        dispatch(removeAdultAction(x.localId));
        dispatch(removeFiles('otherAdultAssessmentFiles', {}));
      })
    }

    dispatch(addNewAdultAction());
    dispatch(setQuestionAnswer(5, ''));
    dispatch(setQuestionAnswer(6, ''));
    dispatch(setQuestionAnswer(7, ''));
    dispatch(setQuestionAnswer(8, ''));
    dispatch(setQuestionAnswer(9, ''));

  }

  return (
    <div>
      <div className="container">
        <main>
          <article>
            {/* <BackAnchor backPath={"routes.income_assistance"} onBackClick={handleReduxCleanup} /> */}
            <div className="row" style={{ paddingTop: "3em" }}></div>
            <div className="row">
              <div className="col-xs-12 col-sm-8">
                <h1 style={{ marginTop: "0" }}>{t("harp_qualify.header")}</h1>
              </div>
              <div className="col-xs-12">
                <p style={{ marginBottom: "20px" }}>
                  {t("harp_qualify.sub_header")}
                </p>
                <p>{t("harp_qualify.para_1")}</p>
              </div>
            </div>

            <div className="row" style={{ marginBottom: "20px" }}>
              <div className="col-xs-10 col-md-12">
                <p style={{ marginBottom: "5px" }}>
                  {t("harp_qualify.para_2")}
                </p>
                <ul>

                  {(!otherAdult && !moreAdults) ?
                    <li>{t("harp_qualify.point_personal_info")}</li>
                    :
                    <>
                      <li>{t("harp_qualify.point_primary_personal_info")}</li>
                      <li>{t("harp_qualify.point_co_applicant_personal_info")}</li>
                    </>
                  }
                  {letter === 'yes' || billUpload ?
                    <li>{t("harp_qualify.point_heating_bill_doc")}</li>
                    :
                    <li>{t("harp_qualify.point_heating_bill")}</li>
                  }
                  {otherAdult ?
                    <li>{t("harp_qualify.point_signature_with_co_applicant")}</li>
                    :
                    <li>{t("harp_qualify.point_signature")}</li>
                  }

                </ul>
              </div>
            </div>
            <ContinueCancelButtons continueClick={onNext} />
          </article>
        </main>
      </div>
    </div>
  );
};

export default withTranslation("common")(QualifyView);
